import { Flux } from './flux';
import { Facture } from './facture';

export class Reglement extends Flux {

    nature_reglement: string;
    facture: Facture;

    constructor() {
        super(); // on appelle le constructeur du parent;
    }

    get source(): string{

        if (this.nature_reglement === 'compte')
        return 'Compte Dépôt';

        if (this.nature_reglement === 'espèce')
        return 'Trésorerie';
    }

}
